import { PortalEnvSchema } from '@playerbase/types';

const env = PortalEnvSchema.parse({
  VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
  VITE_SITE_URL: import.meta.env.VITE_SITE_URL,
});

export function getSiteUrl(): string {
  return env.VITE_SITE_URL ?? (typeof window !== 'undefined' ? window.location.origin : 'http://127.0.0.1:5173');
}
